import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 915.000000 255.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,255.000000) scale(0.100000,-0.100000)"
        >
          <path d="M4572 2298 c-93 -68 -263 -188 -377 -268 -113 -80 -228 -161 -255
-180 -27 -19 -104 -73 -171 -120 -68 -47 -148 -103 -178 -124 -31 -22 -112
-78 -181 -125 -69 -48 -186 -128 -260 -179 -346 -238 -428 -294 -620 -417
-392 -252 -610 -372 -790 -435 -36 -13 -69 -27 -74 -32 -6 -4 159 -8 366 -8
l376 0 54 42 c29 23 136 112 238 198 102 85 223 186 268 224 l84 69 27 -29
c41 -45 299 -361 354 -436 l51 -67 388 -1 c213 0 388 3 388 7 0 8 -115 153
-279 353 -48 58 -118 143 -156 190 -38 47 -77 94 -87 105 -66 78 -228 280
-228 286 0 3 26 28 58 55 31 27 59 51 62 54 3 3 45 39 94 80 48 41 112 95 140
120 29 25 165 141 302 259 137 117 263 225 279 240 17 15 84 71 150 126 213
177 209 179 -23 13z"/>
<path d="M534 2323 c-3 -21 -20 -101 -36 -178 -16 -77 -47 -225 -68 -330 -22
-104 -69 -329 -105 -500 -36 -170 -83 -393 -105 -495 -21 -102 -48 -225 -59
-273 -12 -48 -21 -92 -21 -97 0 -13 608 -13 741 0 520 52 956 228 1240 502
141 135 214 248 276 425 25 72 27 90 27 233 0 145 -2 159 -27 223 -38 96 -104
192 -177 260 -61 56 -102 79 -64 36 l19 -22 -30 7 c-29 7 -29 7 -10 -8 11 -8
16 -15 10 -15 -5 0 -18 5 -27 13 -13 9 -14 16 -6 24 8 8 5 9 -11 5 -11 -3 -21
-11 -21 -18 0 -7 -7 -16 -16 -19 -9 -4 -14 -9 -11 -12 3 -4 -15 -17 -41 -31
-26 -14 -49 -29 -52 -33 -4 -7 -271 -15 -347 -11 -7 1 -13 12 -13 25 0 16 -7
27 -20 31 -16 5 -20 15 -20 46 0 22 -6 48 -12 59 -10 16 -10 24 -1 40 8 12 9
21 2 25 -6 4 -2 19 11 40 13 22 17 36 10 40 -15 9 -2 25 23 26 12 1 2 5 -23
10 -25 4 -266 8 -537 8 l-492 1 -7 -37z m1041 -423 c-3 -5 -12 -10 -18 -10 -7
0 -6 4 3 10 19 12 23 12 15 0z m65 0 c8 -5 11 -10 5 -10 -5 0 -17 5 -25 10 -8
5 -10 10 -5 10 6 0 17 -5 25 -10z m-134 -15 c203 -47 294 -152 294 -336 0
-153 -47 -266 -155 -375 -91 -91 -197 -149 -351 -189 -89 -23 -273 -45 -380
-45 -92 0 -94 1 -94 23 0 23 26 149 74 367 13 58 36 166 51 240 15 74 36 179
48 233 l21 97 216 0 c152 0 233 -5 276 -15z m-523 -12 c-4 -11 -3 -14 5 -9 8
5 8 -1 0 -24 -6 -18 -17 -34 -25 -37 -10 -4 -11 -8 -2 -20 9 -10 9 -17 2 -24
-8 -8 -16 5 -27 44 -20 67 -20 95 0 47 l14 -35 -5 35 c-4 26 -2 31 5 20 9 -13
12 -13 21 3 13 22 20 22 12 0z m637 11 c0 -8 -19 -13 -24 -6 -3 5 1 9 9 9 8 0
15 -2 15 -3z m-690 -98 c0 -26 -6 -18 -14 19 -5 22 -4 26 4 15 5 -8 10 -24 10
-34z"/>
<path d="M5096 2259 c-9 -30 -29 -112 -46 -184 -16 -71 -32 -139 -35 -150 -21
-87 -85 -378 -85 -391 0 -15 21 -16 243 -11 269 6 320 14 422 72 155 87 245
236 245 406 0 141 -62 230 -192 277 -69 24 -86 26 -305 30 l-232 4 -15 -53z
m451 -141 c28 -14 53 -36 64 -58 41 -75 11 -218 -59 -287 -62 -61 -110 -76
-251 -81 l-124 -5 7 44 c4 24 17 94 31 154 13 61 29 139 36 175 7 36 19 71 28
78 11 9 45 11 119 8 84 -3 112 -8 149 -28z"/>
<path d="M6220 2233 c-14 -21 -88 -128 -164 -238 -193 -278 -315 -459 -313
-462 10 -9 178 -13 194 -5 11 6 40 43 64 81 l44 71 171 0 172 0 17 -75 16 -75
77 -1 c42 0 87 -2 100 -3 33 -4 35 7 17 72 -10 31 -33 118 -51 192 -19 74 -51
196 -70 270 -19 74 -40 152 -45 173 l-10 37 -97 0 -97 0 -25 -37z m112 -280
c15 -68 22 -120 17 -124 -11 -6 -196 -5 -203 2 -5 5 144 239 153 239 4 0 19
-53 33 -117z"/>
<path d="M6676 2203 c-9 -38 -16 -74 -16 -80 0 -10 31 -13 121 -13 110 0 120
-2 116 -17 -3 -10 -14 -58 -26 -108 -11 -49 -39 -168 -61 -264 -22 -95 -40
-180 -40 -188 0 -12 16 -14 93 -12 106 3 117 5 117 27 0 18 106 504 117 540 8
23 12 24 118 24 60 0 115 3 122 5 14 5 29 48 38 111 l7 42 -345 0 -344 0 -17
-67z"/>
<path d="M7607 2197 c-55 -82 -162 -234 -180 -257 -12 -16 -76 -108 -131 -190
-16 -25 -56 -82 -89 -127 -32 -45 -56 -87 -52 -93 5 -8 141 -9 196 -1 4 1 29
35 55 76 l49 74 171 1 172 0 17 -72 c10 -40 23 -76 29 -81 17 -12 187 -5 192
8 3 6 -30 146 -72 310 -42 165 -83 328 -91 363 l-15 62 -101 0 -102 -1 -48
-72z m139 -239 c13 -62 22 -119 19 -125 -5 -14 -200 -19 -208 -5 -5 8 155 254
161 248 2 -3 15 -55 28 -118z"/>
<path d="M2082 2186 c21 -12 35 -26 31 -30 -4 -4 1 -4 10 0 15 5 12 10 -20 30
-21 13 -42 23 -48 23 -5 0 7 -10 27 -23z"/>
<path d="M1497 468 c-32 -11 -56 -22 -54 -24 4 -5 127 36 127 42 0 6 -11 4
-73 -18z"/>
<path d="M4630 404 c0 -16 15 -17 167 -11 91 4 321 7 510 7 219 0 342 4 338
10 -3 6 -197 10 -510 10 -466 0 -505 -1 -505 -16z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
